import React from "react";
import "../styles/progressStyles.css";

const Filler = props => {
    let fillerClass = 'filler ';
    if ( typeof props.className !== 'undefined' ) {fillerClass += props.className }
    return <div style={{ width: `${props.value}%` }} className={fillerClass} />;
};

export const ProgressBar = props => {
    let progressClass = 'progress-bar';
    if ( typeof props.className !== 'undefined' ) { progressClass = 'progress-bar progress-bar-small'}
    const progressBarContainerStyle = props.progressBarContainerStyle || {
        border: 0
    };
    return (
        <div style={progressBarContainerStyle} className={progressClass}>
            <Filler value={props.value} />
        </div>
    );
};
